import { HttpInterceptorFn, HttpXsrfTokenExtractor } from '@angular/common/http';
import { inject } from '@angular/core';

/**
 * Adds X-XSRF-TOKEN and withCredentials for API calls to another origin.
 */
export const xsrfCrossOriginInterceptor: HttpInterceptorFn = (req, next) => {
  const isApi = req.url.startsWith('http://localhost:8000/');
  
  if (!isApi) {return next(req);}

  const safe = ['GET','HEAD','OPTIONS'].includes(req.method.toUpperCase());
  const token = inject(HttpXsrfTokenExtractor).getToken() ?? '';
  let clone = req.clone({ withCredentials: true });
  
  if (!safe && token && !req.headers.has('X-XSRF-TOKEN')) {
    clone = clone.clone({ setHeaders: { 'X-XSRF-TOKEN': token } });
  }
  return next(clone);
};
